module.exports = __webpack_public_path__ + "img/img_empty.80cad866.png";